import React, { useState } from 'react';
import {
  styled,
  Button,
  TextField,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginQuery, loginAction } from '../../store/authSlice';

const Login = () => {
  const [userInfo, setUserInfo] = useState({
    login: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const isExisting = userInfo.login && userInfo.password;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginHandler = (e) => {
    e.preventDefault();
    if (isExisting) {
      dispatch(loginQuery({ userInfo, loginAction, navigate }));
      setUserInfo({
        login: '',
        password: '',
      });
    }
  };

  const handlePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <ContainerSignIn>
      <Form onSubmit={loginHandler}>
        <WelcomeText>Добро пожаловать</WelcomeText>
        <InputContainer>
          <TextField
            id="login"
            label="Почта"
            variant="outlined"
            value={userInfo.login}
            onChange={(e) => {
              setUserInfo({ ...userInfo, login: e.target.value });
            }}
          />

          <TextField
            variant="outlined"
            id="password"
            label="Пароль"
            type={showPassword ? 'text' : 'password'}
            value={userInfo.password}
            onChange={(e) =>
              setUserInfo({ ...userInfo, password: e.target.value })
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handlePasswordVisibility}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button type="submit" variant="contained" fullWidth>
            Войти
          </Button>
        </InputContainer>
      </Form>
    </ContainerSignIn>
  );
};

export default Login;

const ContainerSignIn = styled('div')`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #008001;
`;

const Form = styled('form')`
  width: 100%;
  max-width: 450px;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 2px 8px 13px 4px rgba(34, 60, 80, 0.2);
`;

const WelcomeText = styled('p')`
  font-size: 1.5rem;
  text-align: center;
`;

const InputContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
